import Vue from 'vue'
import master from '../masterModules/masterModule.js'

// messageHistory-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  async setMessageHistory(store, payload) {
    store.state.messageHistories = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20,
        searchWord: payload.searchWord
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/messagehistory/list',
      data,
      config
    )
    // 成功
    store.commit('setMessageHistory', response)
  },
  async setDetailMessageHistory(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        callHistoryId: payload.id
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/messagehistory/detail',
      data,
      config
    )
    // 成功
    if (response.data['data'].thumbnailPhotograph == null) {
      store.state.changeThumbnailPhotograph = require('../../../img/noimageicon.png')
    }
    await store.commit('setDetail', response)
  },
  async fileDownload(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30,
      responseType: 'blob'
    }
    var response = await Vue.http.get(
      process.env.API_URL +
        '/v2/admin/userimage/download?filename=' +
        payload +
        '&tenantKey=' +
        header.tenantKey,
      config
    )
    await store.commit('fileDownload', response)
  },
  setNoimageChangeThumbnailPhotograph(store) {
    store.state.changeThumbnailPhotograph = require('../../../img/noimageicon.png')
  },
  fileDownloadErrorFlg(store, payload) {
    store.commit('fileDownloadErrorFlg', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/messageHistoryModules/actions.js